export default __webpack_public_path__ + "static/media/hood_of_the_whispering_blade.87d8f0e8.jpg";